/**
@license
Copyright (c) 2023 Advensys LLC. All rights reserved.
*/

import {
  createSlice
} from '@reduxjs/toolkit'

import { createSelector } from 'reselect';
import { lawyersSelector } from './lawyersSlice.js';

import {dataurl} from '../components/paksh-constants.js'


const idSelector = state => state.lawyer.id;
const itemSelector = state => state.lawyer.item;

const initialState = {
  isFetching: false,
  failure: false,
  item: {},
  id : "",
};


/*
https://github.com/reduxjs/reselect

Accepts one or more "input selectors" (either as separate arguments or a single array),
a single "output selector" / "result function", and an optional options object,
and generates a memoized selector function.

When the selector is called, each input selector will be called with all of the provided
arguments. The extracted values are then passed as separate arguments to the output selector,
which should calculate and return a final result. The inputs and result are cached for later use.

If the selector is called again with the same arguments, the previously cached result is returned
instead of recalculating a new result.
*/

export const lawyerSelector = createSelector(
  idSelector,
  lawyersSelector,
  itemSelector,
  (id, items, item) => {
   return items && items[id] || item;    // THIS WAS CHANGED SO CAN GET detail as list has details missing
   //  item  // THIS WAS CHANGED SO CAN GET detail as list has details missing
  }
  );

export const fetchLawyer = (id) => (dispatch, getState) => {
  const state = getState();
  // const lawyer = state.lawyers && state.lawyers.items && state.lawyers.items[id];
  // console.log(state.lawyer)
    if (state.lawyer.item && id === state.lawyer.item.id) {
       console.log("already there")
    // lawyer found in state.lawyers.items
       // dispatch(lawyerReceived(state.lawyer.item));
    // let the calling code know there's nothing to wait for.
       return Promise.resolve();
      } else {
    // fetch lawyer data given the lawyer id.
    // also return a promise to wait for.
    dispatch(lawyerRequested(id));
    let token = window.localStorage.getItem('token');
    return fetch(`${dataurl}/lawyers/${id}`,
    {
      headers: {
      //  'Content-Type': 'application/json',
      //  'Access-Control-Allow-Credentials': true
        'x-access-token': token
      },
      //  credentials: 'include',
      method: 'GET',
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) {
          dispatch(lawyerFailed(id));
        } else {
          dispatch(lawyerReceived(data));
        }
      })
      .catch((e) => dispatch(lawyerFailed(id)));
  }
}

export const lawyerSlice = createSlice({
  name: 'lawyer',
  initialState,
  reducers: {
    lawyerRequested(state, action) {
      state.item = null; // reset items
      state.failure = false;
      state.isFetching = true;
      state.id = null;
    },
    lawyerReceived(state, action) {
      console.log(action.payload)
      state.isFetching = false;
      state.failure = false;
      state.item = action.payload
      state.id = action.payload.id
    },
    lawyerFailed(state, action) {
      console.log("in lawyersFailed -lawyersSlice")
      state.id = null;
      state.item= null;
      state.failure = true;
      state.isFetching = false;
    },
    lawyerUpdated(state, action) {
      state.item = action.payload
      state.id = action.payload.id
    },
  },
})

export const { lawyerRequested, lawyerReceived, lawyerFailed, lawyerUpdated } = lawyerSlice.actions

// Export the slice reducer as the default export
export default lawyerSlice.reducer